import React from 'react'
import './EmployeeComponents.css'

function WorkloadIndicator({ percentage, showLabel = true, size = 'medium' }) {
  // Определяем цвет в зависимости от загрузки
  const getColor = (percent) => {
    if (percent === null || percent === undefined) {
      return 'var(--color-border)'
    }
    if (percent < 50) {
      return 'var(--color-success)' // Зеленый - низкая загрузка
    } else if (percent < 80) {
      return 'var(--color-warning)' // Желтый - нормальная загрузка
    } else {
      return 'var(--color-error)' // Красный - высокая загрузка
    }
  }

  // Определяем текст статуса
  const getStatusText = (percent) => {
    if (percent === null || percent === undefined) {
      return 'Не рассчитано'
    }
    if (percent < 50) {
      return 'Свободен'
    } else if (percent < 80) {
      return 'Норма'
    } else {
      return 'Перегружен'
    }
  }

  const percent = percentage || 0
  const color = getColor(percent)
  const statusText = getStatusText(percent)
  const sizeClass = `workload-${size}`

  return (
    <div className={`workload-indicator ${sizeClass}`}>
      {showLabel && (
        <div className="workload-label">
          <span className="workload-text">{statusText}</span>
          {percent !== null && percent !== undefined && (
            <span className="workload-percentage">{percent}%</span>
          )}
        </div>
      )}
      <div className="workload-bar-container">
        <div
          className="workload-bar"
          style={{
            width: `${Math.min(percent, 100)}%`,
            backgroundColor: color
          }}
        />
      </div>
    </div>
  )
}

export default WorkloadIndicator

